export function compararArrayOptions(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }

    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i].value !== arr2[i].value ) {
            return false;
        }
    }

    return true;
}

export function filtrosToString(filtros){

    let resp = `?`;
    
    if(filtros.fchMov) resp += `fchMovDesdeDate=${filtros.fchMov.desde.toISOString()}&fchMovHastaDate=${filtros.fchMov.hasta.toISOString()}`

    return resp;
}